import { Button } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

export default function RemoveImage({isHaveImage,handleClick}){
    if(isHaveImage){
        return <img className="p-3 cursor-pointer"  src="images/cross.svg" width="78" onClick={handleClick}/>
    }
}